import React from 'react'
import { Alert as AlertAnt } from 'antd'
import { AlertProps } from 'antd/lib/alert'

import { useT } from 'src/core/hooks/use-translation'

function Alert({
  description,
  message,
  showIcon = true,
  type = 'error',
  ...props
}: AlertProps) {
  const { t } = useT()

  return (
    <AlertAnt
      {...props}
      description={t(description)}
      message={t(message)}
      showIcon={showIcon}
      type={type}
    />
  )
}

export default Alert
